<template>
  <div class="container-fluid error-container d-flex flex-column align-items-center justify-content-center">
    <div class="card shadow text-center" :class="{'bg-dark text-light':darkMode}">
      <div class="card-header">
        <div class="display-2 text-danger"><strong>Error!</strong></div>
      </div>
      <div class="card-body text-center">
        <div class="display-6">Something went wrong please try again later.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  props: {
    darkMode: Boolean
  }
}
</script>

<style scoped>
.error-container {
  position: relative;
  top: .75rem;
  height: calc(100% - 1.5rem);
  overflow: auto;
}
</style>
